import { render, staticRenderFns } from "./agreement-consent.vue?vue&type=template&id=283ab70c&scoped=true"
import script from "./agreement-consent.vue?vue&type=script&lang=ts"
export * from "./agreement-consent.vue?vue&type=script&lang=ts"
import style0 from "./agreement-consent.vue?vue&type=style&index=0&id=283ab70c&prod&scoped=true&lang=scss"
import style1 from "./agreement-consent.vue?vue&type=style&index=1&id=283ab70c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ab70c",
  null
  
)

export default component.exports